import React, { FunctionComponent } from 'react';
import { Dialog } from '@liveramp/motif/core/Dialog';
import Button from '@liveramp/motif/core/Button';
import Radio from '@liveramp/motif/core/Radio';
import RadioGroup from '@liveramp/motif/core/RadioGroup';
import { setArchiveFilterStatus } from 'shared/store/features/archiveFilterStatusSlice';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import useArchiveFilterModalLogic from './useArchiveFilterModalLogic';

interface Props {
  archiveStatusButtonBoundingRect: ClientRect | null;
}

const ArchiveFilterModal: FunctionComponent<Props> = ({
  archiveStatusButtonBoundingRect
}) => {
  const {
    archiveFilter,
    setArchiveFilter,
    initialArchiveStatus,
    useStyles,
    isArchiveFilterModalOpened,
    onClose
  } = useArchiveFilterModalLogic(archiveStatusButtonBoundingRect);
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Dialog
      open={isArchiveFilterModalOpened}
      onClose={onClose}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      aria-labelledby="simple-dialog"
      PaperProps={{
        classes
      }}
    >
      <div className={styles.container}>
        <h3 className={styles.title}>Showing</h3>
        <div className={styles.optionsWrapper}>
          <RadioGroup>
            {
              initialArchiveStatus.map(option => (
                <span
                  key={option.text}
                  className={styles.option}
                >
                  <Radio
                    id={`status-${option.text}-radio-button`}
                    data-test-id={`status-${option.text}-radio-button`}
                    checked={archiveFilter === option.text}
                    onChange={
                      (event: React.ChangeEvent<HTMLInputElement>) => event.target.checked
                        && setArchiveFilter(option.text)
                    }
                  />
                  <label
                    data-test-id={`status-${option.text}-label-for-radio-button`}
                    htmlFor={`status-${option.text}-radio-button`}
                    className={styles.radioLabel}
                  >
                    {option.text}
                  </label>
                </span>
              ))
            }
          </RadioGroup>
          <Button
            data-test-id="apply-archive-filter-button"
            className={styles.submitButton}
            color="primary"
            onClick={() => {
              dispatch(setArchiveFilterStatus({ archiveFilterStatus: archiveFilter }));
              onClose();
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ArchiveFilterModal;
